var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBinIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 4.16675L3.87071 13.3133C3.97465 15.0803 4.02662 15.9638 4.40375 16.6342C4.73573 17.2245 5.23961 17.6996 5.84832 17.9963C6.53978 18.3334 7.4248 18.3334 9.19484 18.3334H10.8039C12.5739 18.3334 13.4589 18.3334 14.1504 17.9963C14.7591 17.6996 15.263 17.2245 15.595 16.6342C15.9721 15.9638 16.024 15.0803 16.128 13.3133L16.666 4.16675M3.33268 4.16675H1.66602M3.33268 4.16675H16.666M16.666 4.16675H18.3327M8.33268 8.33342V14.1667M11.666 8.33342V11.6667M13.3327 4.16675L12.9552 3.03429C12.7913 2.54253 12.7093 2.29665 12.5573 2.11486C12.4231 1.95433 12.2507 1.83007 12.0559 1.75348C11.8354 1.66675 11.5762 1.66675 11.0578 1.66675H8.94087C8.4225 1.66675 8.16332 1.66675 7.94279 1.75348C7.74805 1.83007 7.57565 1.95433 7.4414 2.11486C7.28938 2.29665 7.20742 2.54253 7.0435 3.03429L6.66602 4.16675",
    stroke: "#D12D36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBinIcon);
export default ForwardRef;